import type { PropsWithChildren, ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { StyledJobStatusLabel } from "./styles";

type Props = {
    text?: string;
};

export const CrmEnrichmentJobRunStatusWrapper = ({ children, text }: PropsWithChildren<Props>): ReactElement => {
    return (
        <Flex
            alignItems="center"
            gap="6px"
        >
            <StyledJobStatusLabel>{translate("si.crm-enrichment.job.status.label")}</StyledJobStatusLabel>

            {text ? (
                <Text
                    fontVariant="caption"
                    color={colorsPalettes.carbon["400"]}
                >
                    {text}
                </Text>
            ) : null}

            {children}
        </Flex>
    );
};
